export default __webpack_public_path__ + "static/media/selectingAlgo.e0e11aeb.gif";